exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".search .results {\n  font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif !important;\n  text-shadow: none; }\n  .search .results > .header {\n    font-family: Lato,'Helvetica Neue',Arial,Helvetica,sans-serif !important;\n    text-shadow: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/modules/Menu/search.scss
// module id = 1077
// module chunks = 4